import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Hub } from 'aws-amplify/utils'
import { useQueryClient } from '@tanstack/react-query'
import { useAuthStore } from '../authStore'

/**
 * Hub listener globale sugli eventi Amplify Auth.
 * Replica il listener mobile in `App.js:100-112`.
 *
 * Eventi gestiti:
 *  - `signedOut`           → reset stato + cache, redirect a /login
 *  - `tokenRefresh_failure` → idem (sessione non recuperabile)
 *  - `signedIn`            → niente di esplicito (LoginPage gestisce navigate)
 *
 * Montare UNA volta in alto nel tree (es. dentro AppRoutes).
 */
export function useAuthHub() {
  const navigate = useNavigate()
  const reset = useAuthStore((s) => s.reset)
  const qc = useQueryClient()

  useEffect(() => {
    const unsub = Hub.listen('auth', ({ payload }) => {
      const event = payload.event
      if (event === 'signedOut' || event === 'tokenRefresh_failure') {
        reset()
        qc.clear()
        navigate('/login', { replace: true })
      }
    })
    return () => unsub()
  }, [navigate, reset, qc])
}
